import React from 'react';
import '../stylings/RightSidebar.css';


export default function RightSidebar() {
	return (
		<div className="right-sidebar sidebar-widget widget_intent_latest_posts_widget">
			<h3>Unsere Empfehlungen für Dich</h3>
				
			<ul className="recent_posts_list">
				<li>
					<a href="/entdecken/mephisto">
						<div className="row">
							<div className="col-xlarge-5 col-medium-4 col-small-5">
								<img src="temp/mephisto.jpg" alt="test" className="image" />
							</div>
							<div className="col-xlarge-7 col-medium-8 col-small-7 intent_latest_post_col_right">
								<h4 className="font-montserrat-reg">Mephisto</h4>
								<p className="font-opensans-reg">Alternativ, kultig und zeitlos</p>
							</div>
						</div>
					</a>
				</li>

				<li>
					<a href="/entdecken/egelosia">
						<div className="row">
							<div className="col-xlarge-5 col-medium-4 col-small-5">
								<img src="temp/egelosia.jpg" alt="test" className="image" />
							</div>
							<div className="col-xlarge-7 col-medium-8 col-small-7 intent_latest_post_col_right">
								<h4 className="font-montserrat-reg">eGeLoSIA</h4>
								<p className="font-opensans-reg">„Das süße Leben“ in Koblenz</p>
							</div>
						</div>
					</a>
				</li>
				
				<li>
					<a href="entdecken/mehr-als-rollende-bretter-hungry-hills-die-skateroase">
						<div className="row">
							<div className="col-xlarge-5 col-medium-4 col-small-5">
								<img src="temp/hungryhills.jpg" alt="test" className="image" />
							</div>
							<div className="col-xlarge-7 col-medium-8 col-small-7 intent_latest_post_col_right">
								<h4 className="font-montserrat-reg">Hungry Hills</h4>
								<p className="font-opensans-reg">Mehr als rollende Bretter</p>
							</div>
						</div>
					</a>
				</li>			
			</ul>
		</div>
						
	);
}


// WEBPACK FOOTER //
// ./src/components/RightSidebar/RightSidebar.js